import { getMobileAndDesktopFirstImage } from '../utils';
import { SplitCardSectionProps } from './SplitCardSection';

// TODO Update contentfulSection type
export const parseSplitCardSectionData = (
  contentfulSection: Queries.ContentfulSection001,
): SplitCardSectionProps | null => {
  const { body, eyebrow, metadata, images } = contentfulSection;

  const sectionImages = getMobileAndDesktopFirstImage(images ?? null);

  // Validate that all sections are added in Contentful
  if (!body && !metadata?.description?.description && !eyebrow) {
    return null;
  }

  const SplitCardProps = {
    eyebrow: eyebrow,
    body: body,
    desktopImage: sectionImages.desktopImage,
    mobileImage: sectionImages.mobileImage,
    description: metadata?.description?.description,
  };

  return SplitCardProps;
};
